var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.167 2.66602H12.5003C12.8539 2.66602 13.1931 2.80649 13.4431 3.05654C13.6932 3.30659 13.8337 3.64573 13.8337 3.99935V13.3327C13.8337 13.6863 13.6932 14.0254 13.4431 14.2755C13.1931 14.5255 12.8539 14.666 12.5003 14.666H4.50033C4.1467 14.666 3.80756 14.5255 3.55752 14.2755C3.30747 14.0254 3.16699 13.6863 3.16699 13.3327V3.99935C3.16699 3.64573 3.30747 3.30659 3.55752 3.05654C3.80756 2.80649 4.1467 2.66602 4.50033 2.66602H5.83366",
    stroke: "#2C3335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 1.33398H6.49967C6.13148 1.33398 5.83301 1.63246 5.83301 2.00065V3.33398C5.83301 3.70217 6.13148 4.00065 6.49967 4.00065H10.4997C10.8679 4.00065 11.1663 3.70217 11.1663 3.33398V2.00065C11.1663 1.63246 10.8679 1.33398 10.4997 1.33398Z",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.8b1898aa0424989c9bff006f49593a0c.svg";
export { ForwardRef as ReactComponent };